export default "__VITE_ASSET__SqoFX0fO__"